/* eslint-disable import/prefer-default-export */
const currentVendor: string | undefined =
  process.env.REACT_APP_VENDOR || undefined;

export const isRosselVersion = currentVendor === 'rossel';
export const isRenoVendor = currentVendor === 'reno';
export const getCurrentVendor = () => currentVendor;
